<template lang="pug">
  include /mixins.pug
  div
    vue-easy-lightbox(
      :visible="visible",
      :imgs="source"
      :move-disabled="moveDisabled"
      :index="index"
      :key='galleryIndex'
      @hide="handleHide"
      ref="lightbox",
    )
    slot(
      name='gallery'
      :add='(event) => addListeners(event)'
      :showImg="showImg"
    )

</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'UiGallery',
  props: {
    galleryIndex: {
      type: Number,
    },
    source: {
      type: Array,
    },
  },
  components: {
    VueEasyLightbox,
  },
  data() {
    return {
      visible: false,
      moveDisabled: false,
      index: 0,
      img: [],
    }
  },
  methods: {
    addListeners(slick) {
      const slides = Array.from(
        slick.$list[0].getElementsByClassName('slick-slide')
      )
      slides.forEach(el => {
        const picture = el.querySelector('img')
        const index = picture.dataset.img
        const self = this
        picture.addEventListener('click', () => {
          self.showImg(Number(index))
        })
      })
    },

    showImg(index) {
      if (index.target) {
        // console.log(index.target.dataset.index, '@index')
        this.index = Number(index.target.dataset.index)
      } else {
        // console.log(index, 'index')
        this.index = index
      }
      this.visible = true
    },

    handleHide() {
      this.visible = false
    },
  },
}
</script>
